import { Answer } from './interview-answer';

/**
 * Defines the context item, a question brief that holds, question id and its answer.
 */
export interface ContextItem {
    /**
     * Id of the questions.
     */
    objectKey: string;
    /**
     * answer defined.
     */
    answer: Answer;
    /**
     * Status of that questions
     */
    status: ContextItemStatus;
}
/**
 * Types of question allowed status
 */
export enum ContextItemStatus {
    VALID = 'valid',
    INCONSISTENT = 'inconsistent',
    PENDING = 'pending',
    DISCARDED = 'discarded',
    BLOCKED = 'blocked'
}
